import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { IBannerContext, BannerContext } from 'app/constants/schemas/BannerContext';
import { IBannerTranslation, BannerTranslation } from 'app/constants/schemas/BannerTranslation';
import { Period, PeriodMarshaller } from 'app/constants/schemas/Period';

export interface IBanner extends IEntity {
  attributes: {
    id: EntityStringId;
    name: string;
    period: Period;
    service: string | null;
    weight: number;
  };
  associations: {
    bannerContext: IBannerContext;
    bannerTranslations: IBannerTranslation[];
  };
}

export type Banner = Entity<IBanner>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Banner: IEntityType<IBanner> = vmClient.defineClass({
  typeName: 'Banner',
  version: 3,
  lockable: true,
  persisted: true,
  attributes: {
    name: {
      type: 'string',
      notNull: true,
    },
    period: {
      type: Period,
      marshaller: PeriodMarshaller,
      notNull: true,
    },
    service: {
      type: 'string',
      collection: false,
    },
    weight: {
      type: 'number',
      notNull: true,
    },
  },
  associations: {
    bannerContext: {
      type: BannerContext,
      collection: false,
      notNull: true,
    },
    bannerTranslations: {
      type: BannerTranslation,
      collection: true,
      notNull: true,
    },
  },
});
